import { REMOVER_FILTRO_USUARIO } from '../types'

export default function removerFiltroUsuario (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_USUARIO
  }
}
